module.exports = __webpack_public_path__ + "static/media/clue010201.d88c05e7.jpg";